import { CloseSummaryPanelAction, EntityDiagramActionFn } from '../types';

export const closeSummaryPanelAction: EntityDiagramActionFn<
  CloseSummaryPanelAction
> = (state, _action, _queueEffect) => {
  return { ...state, summaryNodeId: null, highlightedIds: new Set() };
};
